import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { FILE_TYPE, FOLDER_TYPE } from 'Consts/File';
import { dataAttrs } from 'Helpers/Testing';
import FolderItem from './FolderItem';

class FolderViewer extends Component {
  static get DROPPABLE_FILES() {
    return 'droppable-files';
  }

  static get DROPPABLE_FOLDERS() {
    return 'droppable-folders';
  }

  static getDropStyle(style, snapshot) {
    if (!snapshot.isDropAnimating) {
      return style;
    }
    return {
      ...style,
      transitionDuration: '0.001s',
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      hoverFolderID: 0,
    };

    this.handleFolderHover = this.handleFolderHover.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  onDragEnd(result) {
    const { removeFolderItem, moveFile } = this.props;
    const { hoverFolderID } = this.state;
    // don't do anything if the file is dropped outside the droppable area
    // or if the file isn't being dropped over a folder.
    if (
      !result.destination
      || !result.source
      || result.destination.droppableId !== FolderViewer.DROPPABLE_FOLDERS
      || hoverFolderID === 0
    ) {
      return;
    }
    removeFolderItem(parseInt(result.draggableId, 10));
    moveFile(parseInt(result.draggableId, 10), hoverFolderID);
  }

  handleFolderHover(id) {
    this.setState({ hoverFolderID: id });
  }

  render() {
    const {
      folder,
      handleNavigation,
      openRenameModal,
      handleDelete,
      onFileClick,
      fileRowComponent: FileRow,
      onMoveFileClick,
    } = this.props;
    const styleTest = (itemID, snapshot) => {
      const { hoverFolderID } = this.state;
      return {
        backgroundColor:
          snapshot.draggingOverWith && itemID === hoverFolderID
            ? '#dbfcfa'
            : '',
      };
    };
    const getRelatedFiles = () => {
      const files = [];
      folder.children.forEach((child) => {
        if (child.type === FILE_TYPE) {
          files.push(child.id);
        }
      });
      return files;
    };
    const dndFolders = (
      <Droppable droppableId={FolderViewer.DROPPABLE_FOLDERS} isCombineEnabled>
        {(provided, snapshot) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {folder.children
              .filter(child => child.type === FOLDER_TYPE)
              .map(child => (
                <div
                  key={child.id}
                  className="folder-viewer-row"
                  role="presentation"
                  style={styleTest(child.id, snapshot)}
                  {...dataAttrs('folder-viewer-row')}
                >
                  <FolderItem
                    item={child}
                    relatedFileIds={getRelatedFiles()}
                    handleFolderHover={this.handleFolderHover}
                    handleNavigation={handleNavigation}
                    onMoveFileClick={onMoveFileClick}
                    openRenameModal={openRenameModal}
                    handleDelete={handleDelete}
                    canMutate={Boolean(child.relationships.mutateItem)}
                  />
                </div>
              ))}
          </div>
        )}
      </Droppable>
    );
    const dndFiles = (
      <Droppable droppableId={FolderViewer.DROPPABLE_FILES}>
        {provided => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {folder.children
              .filter(child => child.type === FILE_TYPE)
              .map((child, index) => (
                <Draggable key={child.id} draggableId={child.id.toString()} index={index}>
                  {(provided2, snapshot) => (
                    <div
                      ref={provided2.innerRef}
                      {...provided2.draggableProps}
                      {...provided2.dragHandleProps}
                      style={FolderViewer.getDropStyle(
                        provided2.draggableProps.style,
                        snapshot,
                      )}
                    >
                      <div
                        key={child.id}
                        className={
                          child.attributes.isViewed
                            ? 'folder-viewer-row'
                            : 'folder-viewer-row folder-row-unviewed'
                        }
                      >
                        <FileRow
                          item={child}
                          relatedFileIds={getRelatedFiles()}
                          openRenameModal={openRenameModal}
                          handleDelete={handleDelete}
                          onFileClick={onFileClick}
                          onMoveFileClick={onMoveFileClick}
                          canMutate={Boolean(child.relationships.mutateItem)}
                        />
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
            {provided.placeholder}
            {folder.children.map(child => child.type === FILE_TYPE).length
              === 0 && <div className="folder-viewer-row" {...dataAttrs('folder-is-empty-row')}>Folder is empty.</div>}
          </div>
        )}
      </Droppable>
    );

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        {dndFolders}
        {dndFiles}
      </DragDropContext>
    );
  }
}

FolderViewer.propTypes = {
  folder: PropTypes.object.isRequired,
  handleNavigation: PropTypes.func.isRequired,
  removeFolderItem: PropTypes.func.isRequired,
  moveFile: PropTypes.func.isRequired,
  openRenameModal: PropTypes.func,
  handleDelete: PropTypes.func.isRequired,
  onFileClick: PropTypes.func,
  fileRowComponent: PropTypes.node.isRequired,
  onMoveFileClick: PropTypes.func,
};

FolderViewer.defaultProps = {
  openRenameModal: () => ({}),
  onFileClick: () => ({}),
  onMoveFileClick: () => ({}),
};

export default FolderViewer;
